import { EventsTotals, GetEventsResponse } from '@/types/projects.types';
import { PAGINATION_LIMIT } from '@/utils/pagination-constants';
import { ProjectTimeTypes } from '@/store/slices/projects/types';
import { Get } from '@/connection/helpers';

export enum ProjectListSortType {
  dateAsc = 'dateAsc',
  dateDesc = 'dateDesc',
  alphaAsc = 'alphaAsc',
  alphaDesc = 'alphaDesc',
  published = 'published',
  unpublished = 'unpublished',
  registrationAsc = 'registrationAsc',
  registrationDesc = 'registrationDesc',
  eventTypeAsc = 'eventTypeAsc',
  eventTypeDesc = 'eventTypeDesc',
  sessionCountAsc = 'sessionCountAsc',
  sessionCountDesc = 'sessionCountDesc',
}

export const projectTimeTypeMap = {
  [ProjectTimeTypes.Live]: 'live',
  [ProjectTimeTypes.Upcoming]: 'upcoming',
  [ProjectTimeTypes.All]: 'all',
  [ProjectTimeTypes.TestEvents]: 'testEvents',
  [ProjectTimeTypes.Courses]: 'courses',
};

type TGetProjectsRequest = {
  channel: number;
  limit?: number;
  offset?: number;
  sort?: ProjectListSortType | null;
  search?: string;
  selectedEventGroupUuid?: string;
  time?: ProjectTimeTypes;
  /** default is true since this app is about templates */
  templateEvents?: boolean;
  eventType?: string;
  /** includeTemplatesChannel fetches templates from a "special" channel that contains templates that any editor can pull and duplicate from any channel */
  includeTemplatesChannel?: boolean;
  /** v1 events are deprecated for templates, so this option allows you to ignore in the fetch */
  noV1Events?: boolean;
  templateFilters?: { design?: string; categories?: string; favorites?: string; recent?: string };
  excludeTestEvents?: boolean;
};

export function GetProjects({
  channel,
  limit,
  offset,
  sort,
  search,
  selectedEventGroupUuid,
  time,
  templateEvents = true,
  eventType,
  includeTemplatesChannel,
  noV1Events,
  templateFilters,
  excludeTestEvents = true,
}: TGetProjectsRequest): Promise<{ events: GetEventsResponse[]; totals: EventsTotals }> {
  let queryParams = '';
  try {
    const params = new URLSearchParams({
      limit: (limit || PAGINATION_LIMIT).toString(),
      offset: Math.max(0, offset ?? 0).toString(),
      search: search || '',
      sort: sort || ProjectListSortType.dateDesc,
      ...(selectedEventGroupUuid ? { selectedEventGroupUuid } : {}),
      time: (time && projectTimeTypeMap[time]) || 'all',
      ...(templateEvents ? { templateEvents: String(Boolean(templateEvents)) } : {}),
      ...(eventType ? { eventType } : {}),
      ...(includeTemplatesChannel ? { includeTemplatesChannel: String(includeTemplatesChannel) } : {}),
      ...(noV1Events ? { noV1Events: String(noV1Events) } : {}),
      ...(templateFilters?.categories ? { categories: templateFilters.categories } : {}),
      ...(templateFilters?.design ? { design: templateFilters.design } : {}),
      ...(templateFilters?.favorites
        ? { templateFavorites: Boolean(templateFilters?.favorites || '')?.toString() }
        : {}),
      ...(templateFilters?.recent ? { recentTemplates: Boolean(templateFilters?.recent || '')?.toString() } : {}),
      ...(excludeTestEvents ? { excludeTestEvents: 'true' } : {}),
    });
    queryParams = params.toString();
  } catch (e) {
    console.error(e);
  }

  return Get({
    path: `/v3/admin/events/${channel}?${queryParams}`,
  });
}
